module.exports = __webpack_public_path__ + "img/aej1n-66wvl.027.bea6e635.png";